import { getDomainUrl, getHeaders } from 'constants/urls';
import { usePost, useLazyFetch } from 'tools/useFetch';
import Cache from 'tools/Cache';

export const useGetActivities = () => {
    const activityRes = useLazyFetch(
        `${getDomainUrl()}/event-service/notifications?userId=${encodeURIComponent(
            Cache.get('email'),
        )}&pageSize=1000`,
        { headers: getHeaders() },
    );

    return {
        ...activityRes,
        response: activityRes.response || [],
    };
};

export const useAcknowledgeActivities = (body) => {
    const url = `${getDomainUrl()}/event-service/notifications/batch-acknowledge`;
    const activityRes = usePost(url, {
        method: 'POST',
        headers: getHeaders(),
        body,
    });

    return {
        ...activityRes,
        response: activityRes.response,
    };
};

export const useGetNotifications = () => {
    const url = `${getDomainUrl()}/event-service/notifications/summary?userId=${encodeURIComponent(
        Cache.get('email'),
    )}&pageSize=4`;
    const res = useLazyFetch(url, { headers: getHeaders() });
    return res;
};

export const useGetNotificationCount = () => {
    const url = `${getDomainUrl()}/event-service/notifications/count?userId=${encodeURIComponent(
        Cache.get('email'),
    )}`;
    const res = useLazyFetch(url, { headers: getHeaders() });
    return res;
};

export const getUIBuildTimestamp = () => {
    const url = `${window.location.origin}/build.json`;
    return fetch(url);
};
